<section class="filters-panel" aria-labelledby="filters-title">
  <div class="panel-heading">
    <span class="panel-icon"><i class="pi pi-filter"></i></span>
    <div>
      <h2 id="filters-title">Filtros gerais</h2>
      <p>Estes valores serão usados ao abrir qualquer relatório.</p>
    </div>
  </div>

  <div class="filters-grid">
    <div class="field">
      <label for="periodo">Período</label>
      <p-select inputId="periodo" [options]="periods" optionLabel="label"
        optionValue="value" [ngModel]="selectedPeriod"
        (ngModelChange)="selectedPeriodChange.emit($event)" styleClass="report-select" />
    </div>

    <div class="field">
      <label for="cliente">Cliente</label>
      <p-select inputId="cliente" [options]="clients" optionLabel="label"
        optionValue="value" [ngModel]="selectedClient"
        (ngModelChange)="selectedClientChange.emit($event)"
        [loading]="loadingClients" styleClass="report-select" />
    </div>

    <div class="field">
      <label for="posto">Posto</label>
      <p-select inputId="posto" [options]="posts" optionLabel="label"
        optionValue="value" [ngModel]="selectedPost"
        (ngModelChange)="selectedPostChange.emit($event)"
        [loading]="loadingPosts" styleClass="report-select" />
    </div>

    <div class="field">
      <label for="formato">Formato</label>
      <p-select inputId="formato" [options]="formats" optionLabel="label"
        optionValue="value" [ngModel]="selectedFormat"
        (ngModelChange)="selectedFormatChange.emit($event)" styleClass="report-select" />
    </div>
  </div>
</section>